
import request from '@/utils/request.js'


// banner图等
export function getContact() {
  return request({
    url: `/dj-portal-api/public/contact-us`,
    method: "get",
  });
}